import { Grid, Skeleton, Stack } from "@mui/material";
import { TeamMetric } from "src/components";
import { MetricsFilterByOption } from "src/constants";
import { MetricDto, useGetMetricCollection, useRemoveMetricFromCollection } from "src/http";
import { ITeam } from "src/models";
interface IProps {
  team: ITeam;
  filterByOption?: MetricsFilterByOption;
  filterByValue?: string | undefined;
}

const TeamMetricsGrid = (props: IProps) => {
  const { data: metrics, isLoading } = useGetMetricCollection(props.team.metricCollectionGuid);
  const { mutate: removeMetric } = useRemoveMetricFromCollection();

  function filterFn(metric: MetricDto) {
    switch (props.filterByOption) {
      case MetricsFilterByOption.Team: {
        if (props.filterByValue === "None") {
          return metric.assignedTeam == null;
        } else {
          return metric.assignedTeam.name === props.filterByValue;
        }
      }
      case MetricsFilterByOption.ReportingPerson: {
        if (props.filterByValue === "None") {
          return metric.reportingUser == null;
        } else {
          return metric.reportingUser?.displayName === props.filterByValue;
        }
      }
      case MetricsFilterByOption.All:
      default: {
        return true;
      }
    }
  }

  function handleMetricRemoved(metricGuid: string) {
    if (props.team.metricCollectionGuid == null) {
      return;
    }

    removeMetric({
      metricCollectionGuid: props.team.metricCollectionGuid,
      metricGuid: metricGuid,
    });
  }

  return (
    <>
      {isLoading && (
        <Grid container spacing={1} sx={{ p: 1 }}>
          {[...Array(3)].map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
              <Stack spacing={1}>
                <Skeleton variant="rectangular" />
                <Skeleton variant="rectangular" height="250px" />
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}

      {!isLoading && metrics && (
        <Grid container>
          {metrics
            .filter(filterFn)
            .sort((a, b) => a.sortOrder.localeCompare(b.sortOrder))
            .map((metric, index) => (
              <Grid key={metric.guid} size={{ xs: 12, md: 6, lg: 4 }} sx={{ maxHeight: "400px" }}>
                <TeamMetric
                  key={index}
                  metric={metric}
                  metricIndex={index}
                  team={props.team}
                  sx={{ p: { xs: 0.5, sm: 1 }, height: "100%" }}
                  onMetricRemoved={handleMetricRemoved}
                />
              </Grid>
            ))}
        </Grid>
      )}
    </>
  );
};

export { TeamMetricsGrid };
